import React from 'react';
import SignatureModalContent from './SignatureModalContent';
import BaseModal, {
	BaseModalProps,
} from '../../Modules/Base/Components/BaseModal/BaseModal';

interface Props extends BaseModalProps {
	userId: string;
}

const SignatureModal: React.FC<Props> = props => (
	<BaseModal title='base.signature' {...props}>
		<SignatureModalContent userId={props.userId} />
	</BaseModal>
);

export default SignatureModal;
